import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Configuration } from '../../configuration/configuration';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RequestsService {

  private basePathGsitGateway: string;
  private configuration: Configuration = new Configuration();

  constructor(private http: HttpClient, private translator: TranslateService) {
    this.basePathGsitGateway = environment.apiPath;
  }

  /**
   * Peticions tipus GET a GSIT
   * @param urlRequest URL de la operació GET a realitzar
   * @param extraParams Paràmetres opcionals adicionals per a la petició
   * @param tipusResposta Resposta esperada, JSON per defecte. 'arraybuffer' | 'blob' | 'json' | 'text'
   */
  public getGsitGateway(urlRequest: string, extraParams?: any, tipusResposta?: string): Observable<any> {
    const options = this.setOpcions(false, extraParams, tipusResposta);
    const url = this.basePathGsitGateway + urlRequest;
    return this.http.get(url, options);
  }

  /**
   * Peticions tipus POST a GSIT
   * @param urlRequest URL de la operació GET a realitzar
   * @param body Body opcional per a la petició
   * @param extraParams Paràmetres opcionals adicionals per a la petició
   * @param tipusResposta Resposta esperada, JSON per defecte. 'arraybuffer' | 'blob' | 'json' | 'text'
   */
  public postGsitGateway(urlRequest: string, body?: any, extraParams?: any, tipusResposta?: string): Observable<any> {
    const url = this.basePathGsitGateway + urlRequest;
    const requestOptions = this.setOpcions(true, extraParams, tipusResposta);
    return this.http.post(url, body, requestOptions);
  }

  /**
   * Peticions tipus PUT a GSIT
   * @param urlRequest URL de la operació GET a realitzar
   * @param body Body opcional per a la petició
   * @param extraParams Paràmetres opcionals adicionals per a la petició
   * @param tipusResposta Resposta esperada, JSON per defecte. 'arraybuffer' | 'blob' | 'json' | 'text'
   */
  public putGsitGateway(urlRequest: string, body?: any, extraParams?: any, tipusResposta?: string): Observable<any> {
    const url = this.basePathGsitGateway + urlRequest;
    const requestOptions = this.setOpcions(true, extraParams, tipusResposta);
    return this.http.put(url, body, requestOptions);
  }

  /**
   * Peticions tipus DELETE a GSIT
   * @param urlRequest URL de la operació DELETE a realitzar
   * @param extraParams Paràmetres opcionals adicionals per a la petició
   * @param tipusResposta Resposta esperada, JSON per defecte. 'arraybuffer' | 'blob' | 'json' | 'text'
   */
  public deleteGsitGateway(urlRequest: string, extraParams?: any, tipusResposta?: string): Observable<any> {
    const url = this.basePathGsitGateway + urlRequest;
    const requestOptions = this.setOpcions(true, extraParams, tipusResposta);
    return this.http.delete(url, requestOptions);
  }

  /**
   * Genera les opcions amb els paràmetres necesaris per a realitzar les peticions HTTP
   * @param post Boolean que indica si la petició serà de tipus POST
   * @param extraParams Paràmetres opcionals adicionals per a la petició
   * @param tipusResposta Resposta esperada, JSON per defecte. 'arraybuffer' | 'blob' | 'json' | 'text'
   */
  private setOpcions(post: boolean, extraParams?: any, tipusResposta?: string) {
    let _HEADERS: HttpHeaders;
    if (this.translator.currentLang) {
      _HEADERS = new HttpHeaders().set('locale', this.translator.currentLang);
    } else {
      _HEADERS = new HttpHeaders().set('locale', 'ca_ES');
    }
    if (post) {
      _HEADERS.set('Content-Type', 'application/json');
    }

    let options;
    options = {
      headers: _HEADERS,
      withCredentials: this.configuration.withCredentials,
    };
    if (tipusResposta) {
      options.responseType = tipusResposta;
    }
    if (extraParams) {
      options = (Object as any).assign(options, extraParams);
    }

    return options;
  }

}
